import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Common/ReportStyle.css";
import { v4 as uuidv4 } from "uuid";
import { RotateSpinner } from "react-spinners-kit";
import Header from "../Header/Header";
import Navbar from "../Header/Navbar";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
    ROUTER_URL,
    LABEL_NAME,
    exportAsExcel,
    SERVICE_TYPE,
} from "../Common/constant";
import ActionButton from "../Common/ActionButton";
import Button from "@mui/material/Button";
import axios from 'axios';

const RENEWAL_COLUMNS = [
    { id: "Sl_No", label: "Sl No", minWidth: 50 },
    { id: "eiaNo", label: "eIA No", minWidth: 100 },
    { id: "policyNo", label: "Policy Number", minWidth: 100 },
    { id: "premiumDueDate", label: "Premium Due Date", minWidth: 50 },
    { id: "premiumAmount", label: "Premium Amount", minWidth: 50 },
    { id: "createdDate", label: "Premium Paid Date", minWidth: 100 },
    { id: "response", label: "Api Failure Response", minWidth: 100 },
];

const newcol = [...RENEWAL_COLUMNS];

function TataRenewal({ isRenewal }) {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const currentDate = new Date();

    // Format the date components individually
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const day = currentDate.getDate().toString().padStart(2, "0");
    const hours = currentDate.getHours().toString().padStart(2, "0");
    const minutes = currentDate.getMinutes().toString().padStart(2, "0");
    const seconds = currentDate.getSeconds().toString().padStart(2, "0");
    const milliseconds = currentDate
        .getMilliseconds()
        .toString()
        .padStart(3, "0");

    // Combine the components into the desired format
    const timeStamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}00`;

    const [showTable, setShowTable] = useState(false);
    const [responseData, setResponseData] = useState([]);
    const [columndata, setColumnData] = useState([]);
    const [transactionId, setTransactionId] = useState(uuidv4());
    // let columns = isRenewal ? RENEWAL_COLUMNS : columndata;
    const generateNewTransactionId = () => {
        const newTransactionId = uuidv4();
        setTransactionId(newTransactionId);
    };

    const [insurerCode, setInsurerCode] = useState("");
    const [EiaNo, setEiaNo] = useState("");
    const [policyType, setPolicyType] = useState("");
    const [format, setFormat] = useState("");
    const [transactionStatus, setTransactionStatus] = useState("");

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [loading, setLoading] = useState(false);

    function formatDate(dateString) {
        const dateObject = new Date(dateString);
        const day = dateObject.getDate();
        const month = dateObject.getMonth() + 1; // Months are zero-based
        const year = dateObject.getFullYear();

        // Pad single-digit day and month with a leading zero
        const formattedDay = day < 10 ? `0${day}` : day;
        const formattedMonth = month < 10 ? `0${month}` : month;

        return `${formattedDay}/${formattedMonth}/${year}`;
    }

    const handleButtonClick = async (e) => {
        debugger;
        setLoading(true);
        setShowTable(false);
        generateNewTransactionId();

        console.log("button clicked");
        e.preventDefault();
        // const formattedFromDate = formatDate(fromDate);

        // const formattedToDate = formatDate(toDate);
        if (!fromDate || !toDate) {
            alert("Please fill in all mandatory fields");
            setLoading(false);

            return;
        }
        if (format === 'External') {
            // columns.splice(columns.findIndex(e => e.id === "oldValue"), 1);
            // columns.splice(columns.findIndex(e => e.id === "newValue"), 1);
            setColumnData(RENEWAL_COLUMNS)
        } else {
            setColumnData(RENEWAL_COLUMNS)
        }
        const formattedFromDate = new Date(fromDate).toLocaleDateString("en-GB"); // Assumes 'toDate' is in the format "YYYY-MM-DD"

        const formattedToDate = new Date(toDate).toLocaleDateString("en-GB"); // Assumes 'toDate' is in the format "YYYY-MM-DD"

        //Prod

        const BaseUrl = process.env.REACT_APP_API_URL;

        const tataRenewalEndPoint = "/riInsurerBulkService/v1/renewal-failure-report";
        try {
            debugger;
            const response = await fetch(`${BaseUrl}${tataRenewalEndPoint}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    txnId: transactionId,
                    timestamp: "2023-11-20T16:33:25.387994200",
                    Source: {
                        appType: "MOBILE",
                        osVersion: "11",
                        deviceId: "",
                        deviceName: "Mymobile 52",
                        deviceOS: "Android",
                        appVersion: "2.0",
                        clientIp: "0.0.0.0",
                        origin: "",
                    },
                    Customer: {
                        fromDate: formattedFromDate,
                        toDate: formattedToDate,
                        // insuranceCode: "",
                        // policyType: policyType,
                        // flag: "Internal"
                    },
                }),
            });
            if (response.ok) {
                debugger;
                setLoading(false);
                let jsonResponse = await response.json();
                let res = jsonResponse.quotationResponses;

                //conversion start here
                let convertedData = [];
                res.forEach((element, index) => {
                    let temp = {};
                    let colval = RENEWAL_COLUMNS
                    // temp["Sl No"] = "0";
                    colval.forEach((column) => {
                        if (column.id === "Sl_No") {
                            temp[column.label] = index + 1;
                        }
                        //  else if (
                        //     column.id === "requestType" ||
                        //     column.id === "serviceType"
                        // ) {
                        //     temp[column.label] = SERVICE_TYPE[element[column.id]];
                        // } 
                        else {
                            temp[column.label] = element[column.id];
                        }
                    });
                    convertedData.push(temp);
                    temp = {};
                });
                setResponseData(convertedData);
                setShowTable(true);
            } else {
                // Handle errors
                const errorResponse = await response.json();
                setLoading(false);
                setShowTable(false);
                alert(`Error: ${errorResponse.errorDescription}`);
            }
        } catch (error) {
            // Handle network errors or any other exceptions
            setLoading(false);
            setShowTable(false);
        }
    };

    const handleExportClick = () => {
        // Export response data as Excel
        const temp = responseData;
        let result = responseData ? responseData.map((item) => item) : []
        result = result.map((item) => {
            delete item["New Value"];
            delete item["Old Value"];

            return item
        })
        setResponseData(temp);
        exportAsExcel(
            `${"TataRenewal"
            } report From ${fromDate} to ${toDate}.xlsx`,
            result
        );
    };

    const navigate = useNavigate();

    const backClick = () => {
        navigate("/menudisplaypage");
    };

    const resetClick = (e) => {
        e.preventDefault();
        setFromDate("");
        setToDate("");
        setShowTable(false);
        setLoading(false);
        setPolicyType("Select");
        setTransactionStatus("");
        setResponseData(null);
        setFormat("");
        // const columns = isRenewal ? RENEWAL_COLUMNS : ENDOESMENT_COLUMNS;
    };

    const todayDate = new Date().toISOString().split("T")[0];

    const handleDownload = async (row) => {

        const BaseUrl = process.env.REACT_APP_API_URL;

        const UrlViewInsaMatch = "/insurerDataCollection/v1/GetEndorsementPdf";

        try {
            generateNewTransactionId();
            const response = await fetch(`${BaseUrl}${UrlViewInsaMatch}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    txnId: transactionId,
                    timestamp: "2023-07-31T19:43:25.387994200",
                    Source: {
                        appType: "MOBILE",
                        osVersion: "11",
                        deviceId: "",
                        deviceName: "Mymobile 52",
                        deviceOS: "Android",
                        appVersion: "2.0",
                        clientIp: "0.0.0.0",
                        origin: ""
                    },
                    Customer: {
                        endoId: row?.["Transaction ID"],
                        insuranceCmpnyCd: row?.["Insurer Code"]
                    }
                }
                ),
            });

            if (response.ok) {
                const res = await response?.text();
                const linkSource = `data:application/pdf;base64,${res}`;
                const downloadLink = document.createElement("a");
                const fileName = `${row?.["Transaction ID"]}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }

        }
        catch (error) {
            console.error("Error:", error.message);
        }

    }


    const handleDownload_comss = async (row) => {
        //debugger;
        try {
            const BaseUrl = process.env.REACT_APP_API_URL;
            const UrlViewInsaMatch = "/insurerDataCollection/v1/GetEndorsementZipPDF";

            // ✅ Dynamic filename from row data
            const defaultFilename = row?.["Transaction ID"]
                ? `${row["Transaction ID"]}.zip`
                : filename || 'download.zip';

            const response = await axios.post(
                `${BaseUrl}${UrlViewInsaMatch}`,
                {
                    txnId: transactionId,
                    timestamp: new Date().toISOString(),
                    Source: {
                        appType: "WEB",
                        osVersion: "1.0",
                        deviceId: "",
                        deviceName: navigator.userAgent.substring(0, 20),
                        deviceOS: "Web",
                        appVersion: "1.0",
                        clientIp: "0.0.0.0",
                        origin: window.location.origin
                    },
                    Customer: {
                        endoId: row?.["Transaction ID"],
                        insuranceCmpnyCd: row?.["Insurer Code"]
                    }
                },
                {
                    responseType: 'blob', // ✅ Critical for binary
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/zip, application/octet-stream"
                    }
                }
            );

            // ✅ Auto-detect content type from response
            const contentType = response.headers['content-type'];
            const blobType = contentType?.includes('zip')
                ? 'application/zip'
                : contentType || 'application/octet-stream';

            const blob = new Blob([response.data], { type: blobType });

            // ✅ Extract filename from Content-Disposition if available
            const contentDisposition = response.headers['content-disposition'];
            const extractedFilename = contentDisposition
                ?.match(/filename="(.+)"/)?.[1]
                || defaultFilename;

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.setAttribute('download', extractedFilename);
            link.style.display = 'none'; // ✅ Hidden link

            document.body.appendChild(link);
            link.click();

            // ✅ Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('ZIP Download Error:', error.response?.status, error.message);

            // ✅ User-friendly error handling
            if (error.response?.status === 404) {
                alert('File not found. Please try again.');
            } else if (error.response?.status === 500) {
                alert('Server error. Please contact support.');
            }
        }
    };

    return (
        <div>
            <Header />
            <div className="MenuPage">
                <Navbar pageWrapId={"page-wrap"} outerContainerId={"outer-container"} />
            </div>
            <div className="app-insurer">
                <div>
                    <h1 className="heading">
                        Tata Renewal Report
                    </h1>
                </div>

                {/* Add your text fields and button for user input */}
                <div className="row col-12" style={{ "margin-top": "-15px" }}>
                    <div className="col-12">
                        <form method="post">
                            <div class="row">
                                <div className="username col-sm-4 col-xs-12">
                                    <label className="label_cls">{LABEL_NAME.FROM_DATE}</label>
                                    <div class="">
                                        <input
                                            type="date"
                                            name="fromDate"
                                            value={fromDate}
                                            className="inputboxvu_insure form-control"
                                            max={todayDate}
                                            onChange={(e) => setFromDate(e.target.value)}
                                            required
                                            disabled={responseData?.length}
                                        />
                                    </div>
                                </div>
                                <div className="username col-sm-4 col-xs-12">
                                    <label className="label_cls">{LABEL_NAME.TO_DATE}</label>
                                    <div class="">
                                        <input
                                            type="date"
                                            name="toDate"
                                            value={toDate}
                                            className="inputboxvu_insure form-control"
                                            max={todayDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                            required
                                            disabled={responseData?.length}
                                        />
                                    </div>
                                </div>

                                <div className="username col-sm-4 col-xs-12">
                                    <ActionButton
                                        handleBack={backClick}
                                        handleReset={resetClick}
                                        handleSubmit={handleButtonClick}
                                    />
                                </div>
                                <p className="note">
                                    {" "}
                                    Note:{" "}
                                    {isRenewal
                                        ? LABEL_NAME.RENEWAL_NOTE
                                        : LABEL_NAME.ENDORSEMENT_NOTE}
                                </p>
                            </div>
                        </form>
                        <div className="loading">
                            <RotateSpinner size={70} color="#f99117" loading={loading} />
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="item-insurer">
                            <div className="tableContainer-insurer">
                                {showTable && (
                                    <div className="">
                                        <button
                                            onClick={handleExportClick}
                                            className="export-button"
                                        >
                                            Export as Excel
                                        </button>
                                        {/* <Button variant="outlined">Outlined</Button> */}
                                        <div class="">
                                            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                                                <TableContainer sx={{ maxHeight: 440 }}>
                                                    <Table stickyHeader aria-label="sticky table">
                                                        <TableHead>
                                                            <TableRow>
                                                                {columndata.map((column) => (
                                                                    <TableCell
                                                                        key={column.id}
                                                                        align={column.align}
                                                                        style={{ minWidth: column.minWidth }}
                                                                    >
                                                                        {column.label}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {responseData
                                                                .slice(
                                                                    page * rowsPerPage,
                                                                    page * rowsPerPage + rowsPerPage
                                                                )
                                                                .map((row, index) => {
                                                                    return (
                                                                        <TableRow
                                                                            hover
                                                                            role="checkbox"
                                                                            tabIndex={-1}
                                                                            key={row.code}
                                                                        >
                                                                            {columndata.map((column) => {
                                                                                const value = row[column.label];
                                                                                return (
                                                                                    <TableCell
                                                                                        key={column.id}
                                                                                        align={column.align}
                                                                                    >
                                                                                        {/* {column.format && typeof value === 'number'
                                                                                     ? column.format(value)
                                                                                     : value} */}
                                                                                        {value}
                                                                                        {/* {column.id === "status" && value === "Success" && (row["eIA number"] !== "NA" && row["Policy number"] !== "NA") ? ( */}
                                                                                        {/* {!isRenewal && column.id === 'download' &&
                                                                                            <>
                                                                                                {row['Service Type'] == "Communication Address" && row['Insurer Name'] == "ICICI Prudential Life Insurance" ?
                                                                                                    <Button
                                                                                                        variant="contained"
                                                                                                        className="request-button ml-2"
                                                                                                        disabled={!row["Transaction ID"]?.length}
                                                                                                        onClick={() =>
                                                                                                            handleDownload_comss(
                                                                                                                row
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Download Zip
                                                                                                    </Button>
                                                                                                    :
                                                                                                    <Button
                                                                                                        variant="contained"
                                                                                                        className="request-button ml-2"
                                                                                                        disabled={!row["Transaction ID"]?.length}
                                                                                                        onClick={() =>
                                                                                                            handleDownload(
                                                                                                                row
                                                                                                            )
                                                                                                        }
                                                                                                    >
                                                                                                        Download
                                                                                                    </Button>
                                                                                                }

                                                                                            </>
                                                                                        } */}
                                                                                        {/* ) : (
                                              ""
                                            )} */}
                                                                                    </TableCell>
                                                                                );
                                                                            })}
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25, 100]}
                                                    component="div"
                                                    count={responseData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </Paper>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TataRenewal;
